import React from "react";

import { ReactComponent as InstagramLogo } from "src/images/social/instagram-color.svg";
import { ReactComponent as TiktokLogo } from "src/images/social/tiktok-color.svg";
import { ReactComponent as YoutubeLogo } from "src/images/social/youtube-color.svg";
import { ReactComponent as SnapchatLogo } from "src/images/social/snapchat.svg";
import { ReactComponent as FacebookLogo } from "src/images/social/facebook-color.svg";

import CONSTS from "../../../../../helpers/consts";
import { SOCIAL_LABELS } from "src/types";

export default [
  {
    label: (
      <div className="social-platform-tags__item">
        <InstagramLogo />
        {SOCIAL_LABELS[CONSTS.socialProvider.instagram]}
      </div>
    ),
    value: CONSTS.socialProvider.instagram,
  },
  {
    label: (
      <div className="social-platform-tags__item">
        <TiktokLogo />
        {SOCIAL_LABELS[CONSTS.socialProvider.tiktok]}
      </div>
    ),
    value: CONSTS.socialProvider.tiktok,
  },
  {
    label: (
      <div className="social-platform-tags__item">
        <YoutubeLogo />
        {SOCIAL_LABELS[CONSTS.socialProvider.youtube]}
      </div>
    ),
    value: CONSTS.socialProvider.youtube,
  },
  {
    label: (
      <div className="social-platform-tags__item">
        <SnapchatLogo />
        {SOCIAL_LABELS[CONSTS.socialProvider.snapchat]}
      </div>
    ),
    value: CONSTS.socialProvider.snapchat,
  },
  {
    label: (
      <div className="social-platform-tags__item">
        <FacebookLogo />
        {SOCIAL_LABELS[CONSTS.socialProvider.facebook]}
      </div>
    ),
    value: CONSTS.socialProvider.facebook,
  },
];
